(function ($, undefined) {

    'use strict';
    var nextBtn;
    var firstDot;
    var secondDot;
    var recaptcha;
    var tools_form;

    var nextSlide = function () {
        var ctn = $(this).closest('.account-form-outer-ctn');
        var form = ctn.find('form');
        var dots = ctn.find('.slick-dots');

        form.addClass('second');
        dots.find('.slick-active').removeClass('slick-active');
        secondDot.addClass('slick-active');
    };

    var prevSlide = function () {
        var ctn = $(this).closest('.account-form-outer-ctn');
        var form = ctn.find('form');
        var dots = ctn.find('.slick-dots');

        form.removeClass('second');
        dots.find('.slick-active').removeClass('slick-active');
        firstDot.addClass('slick-active');
    };

    var initSignupCaptcha = function (captcha, form) {
        var $form = $(form);
        tools_form.validateForm($form);
        if ($form.hasClass("has-error")) {
            return false;
        }
        $form.find("input[name = 'captcha']").val(captcha);

        $form.submit();

    };

    var init = function () {
        tools_form = Fw.component.models().form;
        recaptcha = Fw.component.models().utils.recaptcha;
        nextBtn = $('.signup-next-btn');
        firstDot = $('.slick-dots .first');
        secondDot = $('.slick-dots .second');

        nextBtn.click(nextSlide);
        secondDot.click(nextSlide);
        firstDot.click(prevSlide);
        
        $('.signup-submit-btn').each(function () {
            var form = $(this).closest('.signup-form');
            if (form.length === 0) {
                form = $(this).closest('.admin-account-form');
            }
            recaptcha(this, initSignupCaptcha, true, form);
        });

    };


    $(window).ready(init);

})(jQuery);
